const GinMass = [
  {
    id: 1,
    title: "Гордон'с Лондон Драй (Великобританія) 1л",
    price: '2400 грн',
    src: require('../img/gordons.webp'),
    text: '50мл - 120 грн',
  },
  {
    id: 2,
    title: "Гордон'с Лондон Драй (Великобританія) 0,5л",
    price: '1200 грн',
    src: require('../img/gordons.webp'),
    text: '',
  },
  {
    id: 3,
    title: "Гордон'с Лондон Драй 0.0 (Великобританія) 1л",
    price: '1900 грн',
    src: require('../img/gordonsba.png'),
    text: '50мл - 95 грн',
  },
  {
    id: 4,
    title: "гордон`c середземноморський апельсин (Великобританія) 0,7л",
    price: '1960 грн',
    src: require('../img/ginorange.png'),
    text: '50мл - 140 грн',
  },
  {
    id: 5,
    title: 'Тенкері №ТЕН (Великобританія) 1л',
    price: '3300 грн',
    src: require('../img/Tanqueray.png'),
    text: '50мл - 165 грн',
  },
];

export default GinMass;
